/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimePatchTypeEnum {
    KICKOFF = 'kickoff',
    REVERSE_KICKOFF = 'reverse_kickoff',
    SET_MATCH_MINUTE = 'set_match_minute',
    STOP_FIRST_HALF = 'stop_first_half',
    REVERSE_STOP_FIRST_HALF = 'reverse_stop_first_half',
    START_SECOND_HALF = 'start_second_half',
    REVERSE_START_SECOND_HALF = 'reverse_start_second_half',
    STOP_SECOND_HALF = 'stop_second_half',
    REVERSE_STOP_SECOND_HALF = 'reverse_stop_second_half',
    MOVE_MATCH = 'move_match',
}
